module.exports = __webpack_public_path__ + "img/eyes_female_round_mask.c2e16820.png";